import { ApiResponseData } from "../../services/YourAppServer/YourAppServerApi.service";

export class GeocodeRequest {
    public Street: string;
    public StreetNumber: string;
    public PostalCode: string;
    public City: string;
    public Country: string;
}

export class Coordinates {
    public Latitude: number;
    public Longitude: number;
}

export class GeocodeResponse implements ApiResponseData {
    public Approximated: boolean;
    public Coordinates: Coordinates;

    DeserializeType(): void {
        // nothing to do here
    }
}
